import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LoadingComponent } from 'src/app/components/loading/loading.component';
import { LoadingService } from 'src/app/components/loading/loading.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, LoadingComponent, TranslateModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  @Input() modalTitle = '';
  @Input() modalId!: string;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  routerSubscription: Subscription;

  constructor(public loadingService: LoadingService, public commonService: CommonService, private router: Router) {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.onCloseModal();
      }
    });
  }

  onCloseModal(): void {
    this.closeModal.emit();
    this.commonService.selectedId = 1;
  }
}
